import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useSupplierInvoicePayment, SupplierInvoicePayment } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<SupplierInvoicePayment>
      useData={useSupplierInvoicePayment}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
